import { toast } from 'sonner';
import { useOrderAgainConfigWithToasts } from '@hero/hooks-shared';

/**
 * Web dashboard wiring for {@link useOrderAgain}. Uses ApiProvider
 * defaults — no carrier/customer SDK distinction.
 */
export function useOrderAgainConfig() {
  return useOrderAgainConfigWithToasts({
    success: message => toast.success(message),
    error: message => toast.error(message),
  });
}

export { useOrderAgainConfigWithToasts } from '@hero/hooks-shared';
